import {
  ApiResponse,
  SearchApi,
  SearchPersonRequest,
  SolrPersonReduced,
  SolrResultSolrPersonReduced,
} from '../../api/core';
import { getAuthMiddleware } from '../../Auth/utils/GetAuthMiddleware';
import * as React from 'react';
import { ReactNode, useContext } from 'react';
import { AuthContext } from '../../Auth/components/AuthProvider';
import SearchResults, { ExternalSearchResultProps } from './SearchResults';
import { personsDefaultSort } from '../../Settings/config';
import { FormattedMessage } from 'react-intl';
import { SearchResultPerson } from './components/SearchResultPerson';
import { personFacetsSettings } from '../../Settings/search/person-facets';
import { personsSortOptions } from '../../Settings/data';
import { useLocation } from 'react-router';

export function SearchResultsPerson(props: ExternalSearchResultProps): ReactNode {
  const {actions} = useContext(AuthContext);
  const api: SearchApi = new SearchApi().withMiddleware(getAuthMiddleware(actions));
  const location = useLocation();

  const renderResult = (result: SolrPersonReduced, index: number): ReactNode =>
    <SearchResultPerson key={index} position={index+1} result={result} redirectPath={location.pathname} />;

  return <SearchResults
    searchFunction={async (requestParameters: SearchPersonRequest): Promise<SolrResultSolrPersonReduced | null> => {
      const results: ApiResponse<SolrResultSolrPersonReduced> = await api.searchPersonRaw(requestParameters);
      if (!results.raw.status) {
        return null;
      }
      return await results.value();
    }}
    externalParams={props.externalParams}
    defaultSortOption={personsDefaultSort}
    facetSettings={personFacetsSettings}
    title={<FormattedMessage id="search.person.banner.subtitle"/>}
    sortOptions={personsSortOptions}
    renderResult={renderResult}
    path={'/search/persons'}
    headerImage={require('../../Settings/img/banners/search/person.svg')}
  />;
}


export default SearchResultsPerson;
